import * as React from 'react';

const HeaderWrapper = (props) => {
  return (
    <div className="m__head">
      {props.children}
    </div>
  )
};

export default HeaderWrapper;
